export const ACTIVE_COMPONENT_DELETE_REASON =
  "Active components cannot be deleted. Deactivate it or set an end date instead of deleting it.";

export const getPayrollComponentDeleteState = (component, saving = false) => {
  if (component?.isActive) {
    return {
      disabled: true,
      reason: ACTIVE_COMPONENT_DELETE_REASON,
    };
  }

  if (saving) {
    return {
      disabled: true,
      reason: "Wait for the current payroll setup change to finish.",
    };
  }

  return {
    disabled: false,
    reason: "Delete this inactive component version",
  };
};
